<template>
    <div class="SettingsTabWrapper">
        <div v-if="getActiveObj.type === 'text' "  class="textSettings_Wrapper">
        <div class="p-3">
            <TextTab />
        </div>
        <div class="LoadEffectsSetting">
            <div v-if="getActiveObj.effectType?.type === 'shadow'">
                <ShadowEffect />
            </div> 
            <EchoEffect v-else-if="getActiveObj.effectType?.type === 'echo'" />
            <GlitchEffect v-else-if="getActiveObj.effectType?.type === 'glitch'" />
            <HollowEffect v-else-if="getActiveObj.effectType?.type === 'hollow'" />
            <LiftEffect v-else-if="getActiveObj.effectType?.type === 'lift'" />
            <NeonEffect v-else-if="getActiveObj.effectType?.type === 'neon'" />
            <SpliceEffect v-else-if="getActiveObj.effectType?.type === 'splice'" />
        </div>
        <div class="sliderWrapper mt-2">
            <div class="d-flex align-items-center justify-content-center">
                <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    Line Height
                </label>
                <div class="flex-1">
                    <input type="range" min='1' max='3' step='0.1' :value="lineheight"  @input="lineHeightadd" class="form-control-range" />
                </div>
                <div class="w-8 text-sm font-bold text-right text-gray-700 ml-2">{{lineheight}}</div>
            </div>
        <div class="d-flex align-items-center justify-content-center">
            <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs"> Letter Spacing</label>
                <div class="flex-1">
                <input type="range" min="0" max="100" step="1" :value="letterSpacing" @input="letterSpacingAdd" class="form-control-range" />
            </div>
            <div class="w-8 text-sm font-bold text-right text-gray-700 ml-2">{{ letterSpacing }}</div>
        </div>

  <!-- <div :style="{ letterSpacing: letterSpacing + 'px' }" class="sample-text mt-3">
     This text will have dynamic letter spacing.
        </div>s="w-8 text-sm font-bold text-right text-gray-700 ml-2">{{letterSpacing}}</div>
                    </div> -->
            <!-- <div class="d-flex align-items-center justify-content-center">
                <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    Border Radius
                </label>
                <div class="flex-1">
                    <input type="range" min='1' max='500' step='1' :value="borderRadius"  @input="borderRadiusadd" class="form-control-range" />
                </div>
                <div class="w-8 text-sm font-bold text-right text-gray-700 ml-2">{{borderRadius}}</div>
            </div> -->
        </div>
    </div> 
        <div v-if="getActiveObj.type === 'Ellipse' || getActiveObj.type === 'Triangle' || getActiveObj.type === 'Rectangle' || getActiveObj.type === 'Line' " class="ShapeSetting_Wrapper">
            <ShapesSettings />
        </div> 
        <div v-if="getActiveObj.type === 'img'" class="ImagesSettings_Wrapper px-3">
            <ImagesSettings />
        </div> 
        <div v-if="getActiveObj.type === 'youtubeApp' || getActiveObj.type === 'vimeoApp' || getActiveObj.type === 'newsApp' || getActiveObj.type === 'clockApp' || getActiveObj.type === 'calendarApp' || getActiveObj.type === 'webpageApp' || getActiveObj.type === 'qrCodeApp' || getActiveObj.type === 'weatherApp'|| getActiveObj.type === 'countdownApp'" class="ImagesSettings_Wrapper px-3">
            <AppsTab />
        </div> 
        <IncedecInput label="DURATION" sublabel="(SECONDS)" />
    </div>
</template>

<script>
import TextTab from "./Settings/Text.vue"
import ShadowEffect from "./Effects/Shadow.vue"
import EchoEffect from "./Effects/Echo.vue";
import GlitchEffect from "./Effects/Glitch.vue";
import HollowEffect from "./Effects/Hollow.vue";
import LiftEffect from "./Effects/Lift.vue";
import NeonEffect from "./Effects/Neon.vue";
import SpliceEffect from "./Effects/Splice.vue";
import IncedecInput from "../incedecInput.vue";
import ShapesSettings from "./Settings/ShapesSettings.vue"
import ImagesSettings from "./Settings/Image.vue"
import AppsTab from "./Settings/AppsTab.vue"
// import { letterSpacing } from "html2canvas/dist/types/css/property-descriptors/letter-spacing";
export default {
    name:"SettingsTab",
    components:{
        TextTab,
        ShadowEffect,
        EchoEffect,
        GlitchEffect,
        HollowEffect,
        LiftEffect,
        NeonEffect,
        SpliceEffect,
        IncedecInput,
        ShapesSettings,
        ImagesSettings,
        AppsTab
    },
    data(){
        return {
            lineheight: 1.2,
            borderRadius:0,
            letterSpacing: 0
        }
    },
    methods: {
    letterSpacingAdd(e) {
      let value = e.target.value;
      this.letterSpacing = value;
      // Dispatch the letterSpacing value to the Vuex store or handle it accordingly
      this.$store.dispatch("setCurrentObjectProperties", { letterSpacing: value });
    },
    lineHeightadd(x){
            let value = x.target.value;
            this.lineheight = value;
            this.$store.dispatch("setCurrentObjectProperties" , { lineHeight: value });
        },
},
    computed: {
        getActiveObj() {
            return this.$store.getters.getActiveObjectprops
        },
    },
    watch:{
        getActiveObj :{
          handler(updatedValues) {
            
            this.lineheight = updatedValues.lineHeight;
            this.letterSpacing = updatedValues.letterSpacing;
            // this.borderRadius = updatedValues.borderRadius;
         
                
            },
            deep: true,
            immediate: true
        }
    },

   
   
}
</script>

<style >
.text-gray-700 {
    color: rgb(73,80,87);
}
.tracking-widest {
    letter-spacing: .1em;
}
.uppercase {
    text-transform: uppercase;
}
.font-semibold {
    font-weight: 600;
}
.text-xs {
    font-size: .75rem;
    line-height: 1rem;
}
.text-left {
    text-align: left;
}
.block {
    display: block;
}
.text-gray-500{
    color: rgb(172,181,189);

}
.font-semibold {
    font-weight: 600;
}
.font-bold {
    font-weight: 700;
}
.text-2xl {
    font-size: 1.5rem;
}
.bg-purple-600 {
    background-color: rgb(112,72,232,1);
}
.w-10 {
    width: 2.5rem;
}
.h-10 {
    height: 2.5rem;
}
.whitespace-nowrap {
    white-space: nowrap;
}
.plusminusBtn{
    display: flex;
    width: 2.5rem;
    justify-content: center;
    height: 2.5rem;
    cursor: pointer;
}
.plusminusBtn:hover{
    background-color: rgb(80 40 198);
}
.w-24 {
    width: 6rem;
}
.w-8 {
    width: 2rem;
}
.\!text-2xs {
    font-size: .625rem!important;
}
</style>